<button
  (click)="closeSidenav()"
  mat-icon-button
  class="close-button"
  aria-label="Close menu"
>
  <mat-icon matListIcon>close</mat-icon>
</button>
@if (currentDealer(); as currentDealer) {
  <mat-nav-list>
    <a mat-list-item routerLink="/dashboard" (click)="closeSidenav()"
      >Dashboard</a
    >
    @if (newSite()) {
      @for (moduleGroup of moduleGroups(); track moduleGroup) {
        <!-- ignore group that has no display name - these are the modules that are not listed in the header -->
        @if (moduleGroup.displayName) {
          <!-- See desktop.component.html for why a single-module group can
          render as a plain link under the group's own name (EXT-5379). -->
          @if (
            moduleGroup.modules.length === 1 &&
            (moduleGroup.displayName === moduleGroup.modules[0].displayName ||
              moduleGroup.collapseWhenSingle)
          ) {
            <a
              mat-list-item
              [routerLink]="moduleGroup.modules[0].routes[0]"
              (click)="closeSidenav()"
              >{{ moduleGroup.displayName }}</a
            >
          } @else {
            <mat-expansion-panel class="mat-elevation-z0">
              <mat-expansion-panel-header>
                <mat-panel-title>{{ moduleGroup.displayName }}</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                @for (
                  module of moduleGroup.modules;
                  track [module.displayName, module.routes]
                ) {
                  <a
                    mat-list-item
                    [routerLink]="module.routes[0]"
                    (click)="closeSidenav()"
                    >{{ module.displayName }}</a
                  >
                }
              </mat-nav-list>
            </mat-expansion-panel>
          }
        }
      }
    } @else {
      @if (currentDealer.role === "Owner") {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Reports</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a
              [disabled]="!enableDealerReports"
              mat-list-item
              (click)="closeSidenav()"
              routerLink="/reports/commission-statements"
              >Statements</a
            >
          </mat-nav-list>
        </mat-expansion-panel>
      }
      <mat-list-item (click)="closeSidenav()" class="top-link">
        <a routerLink="/support">Support</a>
      </mat-list-item>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Setup</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a
            mat-list-item
            routerLink="/setup/account-info"
            (click)="closeSidenav()"
            >Account Info</a
          >
          @if (
            currentDealer.role === "Manager" || currentDealer.role === "Owner"
          ) {
            <a
              mat-list-item
              routerLink="/setup/users/manage"
              (click)="closeSidenav()"
              >Manage Users</a
            >
          }
        </mat-nav-list>
      </mat-expansion-panel>
    }
    <a mat-list-item (click)="onSignOut(); closeSidenav()">Sign Out</a>
  </mat-nav-list>
}
